export class QueryError extends Error {
  name = 'QueryError';

  constructor(...args: ConstructorParameters<typeof Error>) {
    const [message = `Unknown failure`, ...p] = args;

    super(message, ...p);
  }
}

export class CancledQueryError extends QueryError {
  name = 'CancledQueryError';

  constructor(...args: ConstructorParameters<typeof QueryError>) {
    const [message = `Query cancelled`, ...p] = args;

    super(message, ...p);
  }
}

export class TimeoutQueryError extends QueryError {
  name = 'TimeoutQueryError';

  constructor(...args: ConstructorParameters<typeof QueryError>) {
    const [message = `Query timeout`, ...p] = args;

    super(message, ...p);
  }
}

export class StatusQueryError extends QueryError {
  name = 'StatusQueryError';

  constructor(
    public status: number,
    message?: string,
    // TODO: need refactor for error code to split to different categories with different handling
    public errorCode?: number,
    public details?: unknown,
    options?: ErrorOptions,
  ) {
    super(message, options);
  }
}
